<mat-card>
  <mat-toolbar>Owners
    <span class="fill-remaining-space"></span>
    <button mat-icon-button matTooltip="Show/Hide search" aria-label="Show/hide search" matTooltipClass="tooltip-style" (click)="toggleFiltersVisibility()" style="float: right; margin-right: 0">
        <mat-icon color="primary" style="font-size:24px">filter_list</mat-icon>
    </button>
    <button mat-icon-button style="float: right; width:70px; margin-right: 0" mat-icon-button (click)="addOwner()" matTooltip="New owner" aria-label="New owner" matTooltipClass="tooltip-style">
        <mat-icon color="primary" style="font-size:24px">add</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Export list" aria-label="Export list" matTooltipClass="tooltip-style" (click)="this.exportar()" style="float: right; margin-right: 0">
      <mat-icon  color="primary" style="font-size:24px">vertical_align_bottom</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card-content>
    <mcrit-gestio-owners-filters
      *ngIf="showFilters"
      [validFilters]="ownersFilters"
      (changeFilter)="computeActiveFilters($event)">
    </mcrit-gestio-owners-filters>
    <table>
      <thead>
        <tr>
          <th class="actions-column-header">Actions</th>
          <th *ngFor="let field of tableFields; let i = index" (click)="cycleOrdering(field[0])" style="vertical-align: top">
            {{field[1]}}
            <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters[field[0]] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters[field[0]] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon>
          </th>
        <tr>
      </thead>
      <tbody *ngIf="ownerData">
        <tr *ngFor="let owner of ownerData.rows;" style="cursor:pointer">
          <td class="actions-cell">
              <button mat-icon-button [matMenuTriggerFor]="actionMenu" 
              [matMenuTriggerData]="{ Id: owner['id'], VehId: owner['plate'] }"
              matTooltip="Opcions"
              matTooltipClass="tooltip-style">
                <mat-icon color="primary">more_vert</mat-icon>
              </button>
          </td>
          <td *ngFor="let field of tableFields;let i = index" (click)="editOwner(owner)">
            <div style="float: left;clear: none;padding-right: 5px">&nbsp;{{owner[field[0]]}}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-content>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      Rows per page: {{listOwnerService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em" *ngIf="ownerData">
      {{firstRegisterShown}} - {{lastRegisterShown}} de {{ownerData.registers}} owners
    </span>
    <button mat-icon-button (click)="gotoPage(0)">
      <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
</mat-card>
<mat-menu #menuNumberRows y-position="above">
    <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
</mat-menu>

<mat-menu #actionMenu="matMenu" xPosition="after">
  <ng-template matMenuContent let-vehid="VehId">
    <button mat-menu-item (click)="go('vehicles', vehid)">
      <mat-icon color="primary">commute</mat-icon>
      <span>Vehicles</span>
    </button>
  </ng-template>
</mat-menu>